<script>
import {
  likeArticleResource,
  likeEventResource,
} from '@/js/services/common.service'

const resources = {
  article: likeArticleResource,
  event: likeEventResource,
}

export default {
  name: 'LikeButton',

  props: {
    isLiked: {},
    likesCount: {},
    type: {},
    id: {},
  },

  data() {
    return {
      isLikedLocal: this.isLiked,
      likesCountLocal: this.likesCount,
    }
  },

  methods: {
    likeUpdate() {
      const formdata = { id: this.id }

      resources[this.type].execute({}, formdata).then(() => {
        this.updateLikesCounter()
        this.isLikedLocal = !this.isLikedLocal
      })
    },

    updateLikesCounter() {
      if (this.isLikedLocal) {
        this.likesCountLocal--
      } else {
        this.likesCountLocal++
      }
    },
  },

  render() {
    return this.$scopedSlots.default({
      likeUpdate: this.likeUpdate,
      likesCountLocal: this.likesCountLocal,
      isLikedLocal: this.isLikedLocal,
    })
  },
}
</script>
